module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/TV#2-be6ad172ef497e4212736bc54f502ee1c7d73eb5f88d06c1db8db9f27b267f3f.svg";